<div class="container-fluid my-2">
  <div class="row">
    <router-outlet></router-outlet>
  </div>
</div>
